import { AxiosResponse } from 'axios';
import { getData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

interface ActivityLogRequest {
  take?: number;
  page?: number;
  itemId?: string;
  modifiedBy?: string;
  module?: string;
}

interface ActivityLogResponse {
  total: number;
  take: number;
  page: number;
  data: any[];
}

export const getActivityLogRepository = async (url: string, request: ActivityLogRequest): Promise<any> => {
  const response: AxiosResponse<ActivityLogResponse> = await getData<ActivityLogRequest, ActivityLogResponse>(
    API_URLS.ACTIVITY_LOG,
    request,
  );
  return response.data;
};
